import { render } from "./WeddingDay.vue?vue&type=template&id=02afb549"
import script from "./WeddingDay.vue?vue&type=script&lang=js"
export * from "./WeddingDay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__